import { graphql } from '@shared/api/gql';

export const getArticleQueryDocument = graphql(`
	query GetArticle($id: ID!) {
		article(id: $id) {
			id
			IssueID
			isFeatured
			features
			thumbnail
			components
			slug
			role
			style
			featureImage
			name
			slug
			features
			keywords
			channel
			styleProperties
			index
			description
			pages
			style
			updated
			releaseDate
			created
			replica {
				name
				page
				image
				hotspots {
					url
					area {
						x
						y
						width
						height
					}
				}
			}
			styles {
				id
				name
				description
				properties
				supportedDevices
				type
				parent
				tablet
				desktop
				created
				lastModified
			}
		}
	}
`);
